import React from 'react';
import PropTypes from 'prop-types';
import { CompanyDataDiv } from '../../Companies/CompaniesHome/CompanyHome.styles';

// prettier-ignore
const UserData = ({ user }) => {
    console.log('User data', user);
    return (
        <CompanyDataDiv>
            <h4>User Details</h4>
            {user?.type && (
                <p>
                    <strong>Type:</strong> {user?.type}
                </p>
            )}
            {user?.email && (
                <p>
                    <strong>Email:</strong> {user?.email}
                </p>
            )}
            {user?.phone && (
                <p>
                    <strong>Phone:</strong> {user?.phone}
                </p>
            )}
            {user?.company?.[0] && (
                <>
                    <p>
                        <strong>Company:</strong>{' '}
                        {user?.company?.[0]?.companyId?.companyName || 'N/A'}
                    </p>
                    <p>
                        <strong>Role:</strong> {user?.company?.[0]?.role || 'N/A'}
                    </p>
                </>
            )}
            {user?.createdAt && (
                <p>
                    <strong>Created At:</strong>{' '}
                    {new Date(user?.createdAt).toLocaleDateString()}
                </p>
            )}
            {user?.updatedAt && (
                <p>
                    <strong>Updated At:</strong>{' '}
                    {new Date(user?.updatedAt).toLocaleDateString()}
                </p>
            )}
            {user?.lastLogin && (
                <p>
                    <strong>Last Login:</strong>{' '}
                    {new Date(user?.lastLogin).toLocaleDateString()}
                </p>
            )}

            {user?.active !== undefined && (
                <p>
                    <strong>Active:</strong>{' '}
                    {user?.active ? 'User is active' : 'User is not active'}
                </p>
            )}
            {user?.accountDetailsEmailSent !== undefined && (
                <p>
                    <strong>Account Details Email Sent:</strong>{' '}
                    {user?.accountDetailsEmailSent
                        ? 'User has recieved account details email'
                        : 'User has not recieved account details email'}
                </p>
            )}
        </CompanyDataDiv>
    );
};
UserData.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    type: PropTypes.string,
    accountDetailsEmailSent: PropTypes.bool,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    lastLogin: PropTypes.string,
    active: PropTypes.bool,
    company: PropTypes.arrayOf(
      PropTypes.shape({
        companyId: PropTypes.shape({
          companyName: PropTypes.string,
        }),
        role: PropTypes.string,
      })
    ),
  }),
};

export default UserData;
